import * as React from "react";
import { SettingRow, SettingSelect } from "./SettingsWidgets";
var LandlordSelector = function (props) {
    var handleChange = function (e) {
        if (e.target.value === "") {
            props.onChange(null);
        }
        else {
            props.onChange(parseInt(e.target.value, 10));
        }
    };
    return (React.createElement(SettingRow, { label: "Current leader", htmlFor: "landlord-selector" },
        React.createElement(SettingSelect, { id: "landlord-selector", value: props.landlordId === null ? "" : props.landlordId, onChange: handleChange },
            React.createElement("option", { value: "" }, "determined by the bid"),
            props.players.map(function (player) { return (React.createElement("option", { value: player.id, key: player.id }, player.name)); }))));
};
export default LandlordSelector;
